import { PaginationState } from '@tanstack/react-table';
import { PUBLICATION_TYPE, PublicationType } from '@shared/types/enums';

// #region Dates
export const DATE_CALENDER_YMD = 'yyyy/mm/dd';
export const DATE_YM = 'YYYY/MM';
export const DATE_YMD = 'YYYY/MM/DD';
export const DATE_YMD_FNS = 'yyyy/MM/dd';
export const DATE_TIME_YMD = 'YYYY/MM/DD HH:mm';
export const DATE_TIME_FULL = 'YYYY/MM/DD HH:mm:ss';
export const DATE_YMD_ISO = 'YYYY-MM-DD';
export const DATE_TIME_YMD_ISO = 'YYYY-MM-DD HH:mm';
export const DATE_TIME_FULL_ISO = 'YYYY-MM-DD HH:mm:ss';
export const DATE_YMD_JP = 'YYYY年MM月DD日';
// #endregion Dates

export const SYSTEM = {
    CMS: 0,
    ENDUSER: 1
};

// #region Table
export const DEFAULT_SELECT_PAGE_SIZES: number[] = [10, 50, 100, 500, 1000];

export const DEFAULT_PAGINATION: PaginationState = {
    pageIndex: 0,
    pageSize: 10
};
// #endregion Table

// #region Maxlength
export const MAX_LENGTH = {
    Input: 255,
    Textarea: 500
};
// #endregion Maxlength

// #region step registration
export const STEP_ONE = {
    CONFIRM_TERM: 1,
    INPUT_EMAIL: 2
};

export const PATTERN_STRING_ONLY = /^\d+\.?\d*$/;

export const STEP_REGISTRATION_CONFIG = [
    {
        step: 1,
        content: '1. 登録前確認'
    },
    {
        step: 2,
        content: '2. 情報登録'
    },
    {
        step: 3,
        content: '3. 登録完了'
    }
];
// #endregion

// #region Regex
export const REGEX_VALIDATE_EMAIL = /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)+$/;
// #endregion Regex

// #region Publication Tab
// Map URL tab values to PublicationType enum
export const PUBLICATION_TAB_URL_TO_ENUM: Record<string, PublicationType> = {
    'book': PUBLICATION_TYPE.Book,
    'magazine': PUBLICATION_TYPE.MagazineIssue
};

// Map PublicationType enum to URL tab values
export const PUBLICATION_TAB_ENUM_TO_URL: Record<PublicationType, string> = {
    [PUBLICATION_TYPE.Book]: 'book',
    [PUBLICATION_TYPE.MagazineIssue]: 'magazine'
};
// #endregion Publication Tab
